{
  "actions": "פעולות",
  "hideButtonLabel": "הצג פחות",
  "showAllButtonLabel": "הצג הכל ({tagCount, number})"
}
